module.exports = "<select name=\"{{name}}\" class=\"form-control dropdown-toggle m-t-sm\" [(ngModel)]=\"value\" (change)=\"valueChange.emit(value)\">\r\n  <option *ngFor='let item of listItems' [value]=\"item.key\">{{item.label}}</option>\r\n</select>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common/dropdown/dropdown.component.html
// module id = ./src/app/components/common/dropdown/dropdown.component.html
// module chunks = main